/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ProfileSaveRequest} from '../models/ProfileSaveRequest';

export interface CreateAccessRightsProfiles$Request {
    profileSaveRequest: ProfileSaveRequest;
}

export interface CreateAccessRightsProfiles$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createAccessRightsProfilesRequest = createAction<PayloadData<void, CreateAccessRightsProfiles$Request>>('CREATE_ACCESS_RIGHTS_PROFILES__CREATE_ACCESS_RIGHTS_PROFILES__REQUEST');
export const createAccessRightsProfilesSuccess = createAction<PayloadData<number, CreateAccessRightsProfiles$Request>>('CREATE_ACCESS_RIGHTS_PROFILES__CREATE_ACCESS_RIGHTS_PROFILES__SUCCESS');
export const createAccessRightsProfilesFailure = createAction<PayloadData<Error, CreateAccessRightsProfiles$Request, true>>('CREATE_ACCESS_RIGHTS_PROFILES__CREATE_ACCESS_RIGHTS_PROFILES__FAILURE');

export const createAccessRightsProfilesActions = [
    createAccessRightsProfilesRequest,
    createAccessRightsProfilesSuccess,
    createAccessRightsProfilesFailure
] as const;

/**
 * @param {ProfileSaveRequest} meta.profileSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createAccessRightsProfiles = (meta: CreateAccessRightsProfiles$Request, config?: CreateAccessRightsProfiles$Config) => {
    return {
        CALL_API: {
            types: createAccessRightsProfilesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/admins/profiles`,
            TRANSPORT_REQUEST_BODY: meta.profileSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

